import { fromJS, Map, Record, Set } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Link } from '#utils/linkUtils';
import type { MemberSummary } from '#utils/members/records/MemberSummary';
import { createMemberSummary } from '#utils/members/records/MemberSummary';

type AccessTokenProps = {
  _links: Link;
  _id: string;
  _member: null | MemberSummary;
  name: string;
  token: string;
  role: string;
  customRoleIds: Set<string>;
  inlineRole: string | null | string[];
  defaultApiVersion: null | number | string;
  serviceToken: boolean;
  lastUsed: number;
  creationDate: number;
};
export class AccessToken extends Record<AccessTokenProps>({
  _links: Map(),
  _id: '',
  _member: null,
  name: '',
  token: '',
  role: '',
  customRoleIds: Set(),
  inlineRole: null,
  defaultApiVersion: null,
  serviceToken: false,
  lastUsed: -1,
  creationDate: 0,
}) {}

export const createAccessToken = (props?: CreateFunctionInput<AccessToken>) => {
  const token = props instanceof AccessToken ? props : new AccessToken(fromJS(props));
  return token.withMutations((t) => {
    t.update('_member', (m) => (m ? createMemberSummary(m) : null));
    t.update('customRoleIds', (rs) => (rs ? rs.toSet() : rs));
  });
};
